<template>
    <div>
        <div class="navigator">
            <h2 class="mr-auto">New Reservation</h2>
        </div>

        <div class="new-reservation d-flex">
            <div class="main-column p-4">
                <agent @updateFields="updateFields"></agent>

                <basic></basic>

                <price-counters @updatePrices="updatePrices"></price-counters>

                <customer @updateFields="updateFields"></customer>

                <transport @updateFields="updateFields"></transport>

                <extras @updateExtras="updateExtras" :editable="true"></extras>

                <notes @updateNotes="updateNotes"></notes>
            </div>

            <summary-panel></summary-panel>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Agent from './Agent'
    import Basic from './BasicData'
    import PriceCounters from './PriceCounters'
    import Customer from './Customer'
    import Transport from './Transport'
    import Extras from './Extras'
    import Notes from './Notes'
    import SummaryPanel from './summary/Summary'

    export default {
        data: function() {
            return {
                form: {}
            }
        },
        created: function() {
            if (!this.getClonedReservation) {
                if (this.getSelectedReservation) {
                    this.updateClonedReservation(JSON.parse(JSON.stringify(this.getSelectedReservation))).then(() => {
                        this.form = this.getClonedReservation;
                    });
                }
                else {
                    // Sets clonedReservation to a blank state. We'll always have a cloneReservation,
                    // be it blank or with the editable object

                    this.resetClonedReservation().then(() => {
                        this.form = this.getClonedReservation;
                        console.log('reset cloned reservation with', this.form)
                    });
                }
            }
            else {
                this.form = this.getClonedReservation;
            }

            console.log('Starting reservation form with this.form', this.form);
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getSelectedReservation',
            ]),
        },
        methods: {
            ...mapActions([
                'updateClonedReservation',
                'resetClonedReservation',
            ]),
            updateFields: function(fields) {
                Object.keys(fields).forEach((key) => {
                    this.$set(this.form, key, fields[key]);
                });

                this.updateClonedReservation(this.form);
            },
            updatePrices: function(prices) {
                this.form.event.product.prices = prices;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updatePrices trigger for prices', prices, ' with ', this.getClonedReservation);
            },
            updateExtras: function(extras) {
                this.form.event.product.extras = extras;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updateExtras trigger for extras', extras, ' with ', this.getClonedReservation);
            },
            updateNotes: function(notes) {
                this.form.notes = notes;

                this.updateClonedReservation(this.form);

                console.log('Updated clonedReservation after updateNotes trigger for notes', notes, ' with ', this.getClonedReservation);
            },
        },
        components: {
            Agent,
            Basic,
            PriceCounters,
            Customer,
            Transport,
            Extras,
            Notes,
            SummaryPanel
        },
    }
</script>

<style lang="scss">
    .new-reservation {
        height: 86.5vh;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// Form.vue?42178ca1